import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";

export const useKeyword = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const headerState = useFxSelector(schema.uiJGBrowserHeader.select);

  return useMemo(() => {
    if (process.env.REACT_APP_MODE === "DELPHI") {
      return params.get("keyword");
    } else {
      return headerState.tabSelected;
    }
  }, [location, headerState.tabSelected]);
};
